import { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";

import BotonExportarCSV from "../../components/admin/BotonExportarCSV";
import TablaCitasClientes from "../../components/admin/TablaCitasClientes";
import TablaCitasFicticias from "../../components/admin/TablaCitasFicticias";
import AdminEstadisticas from "../../components/admin/AdminEstadisticas";

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } = process.env;
const supabase = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY);

const CITAS_POR_PAGINA = 10;

const AdminCitas = () => {
    const [citasNormales, setCitasNormales] = useState([]);
    const [loadingNormales, setLoadingNormales] = useState(false);
    const [paginaNormales, setPaginaNormales] = useState(1);
    const [totalCitasNormales, setTotalCitasNormales] = useState(0);

    const [citasFicticias, setCitasFicticias] = useState([]);
    const [loadingFicticias, setLoadingFicticias] = useState(false);
    const [paginaFicticias, setPaginaFicticias] = useState(1);
    const [totalCitasFicticias, setTotalCitasFicticias] = useState(0);

    const [filtroFecha, setFiltroFecha] = useState(null);

    const fetchCitasNormales = async () => {
        setLoadingNormales(true);
        let query = supabase.from("citas").select("*", { count: "exact" }).neq("tipo_de_masaje", "Bloqueado").order("hora", { ascending: false });

        if (filtroFecha) {
            const desde = new Date(filtroFecha); desde.setHours(0, 0, 0, 0);
            const hasta = new Date(filtroFecha); hasta.setHours(23, 59, 59, 999);
            query = query.gte("hora", desde.toISOString()).lte("hora", hasta.toISOString());
        }

        const desde = (paginaNormales - 1) * CITAS_POR_PAGINA;
        const hasta = desde + CITAS_POR_PAGINA - 1;
        const { data, error, count } = await query.range(desde, hasta);

        if (!error) { setCitasNormales(data || []); setTotalCitasNormales(count || 0); }
        setLoadingNormales(false);
    };

    const fetchCitasFicticias = async () => {
        setLoadingFicticias(true);
        let query = supabase.from("citas").select("*", { count: "exact" }).eq("tipo_de_masaje", "Bloqueado").order("hora", { ascending: false });

        if (filtroFecha) {
            const desde = new Date(filtroFecha); desde.setHours(0, 0, 0, 0);
            const hasta = new Date(filtroFecha); hasta.setHours(23, 59, 59, 999);
            query = query.gte("hora", desde.toISOString()).lte("hora", hasta.toISOString());
        }

        const desde = (paginaFicticias - 1) * CITAS_POR_PAGINA;
        const hasta = desde + CITAS_POR_PAGINA - 1;
        const { data, error, count } = await query.range(desde, hasta);

        if (!error) { setCitasFicticias(data || []); setTotalCitasFicticias(count || 0); }
        setLoadingFicticias(false);
    };

    useEffect(() => { setPaginaNormales(1); setPaginaFicticias(1); }, [filtroFecha]);
    useEffect(() => { fetchCitasNormales(); }, [paginaNormales, filtroFecha]);
    useEffect(() => { fetchCitasFicticias(); }, [paginaFicticias, filtroFecha]);

    const ejecutarEliminacion = async (id, esFicticia) => {
        if (!window.confirm("¿Seguro que quieres eliminar esta cita?")) return;
        await supabase.from("citas").delete().eq("id", id);
        if (esFicticia) fetchCitasFicticias(); else fetchCitasNormales();
    };

    const toggleConfirmada = async (id, current) => {
        await supabase.from("citas").update({ confirmada: !current }).eq("id", id);
        fetchCitasNormales();
    };

    const togglePago = async (id, current) => {
        await supabase.from("citas").update({ ha_pagado: !current }).eq("id", id);
        fetchCitasNormales();
    };

    const totalPaginasNormales = Math.ceil(totalCitasNormales / CITAS_POR_PAGINA) || 1;
    const totalPaginasFicticias = Math.ceil(totalCitasFicticias / CITAS_POR_PAGINA) || 1;

    return (
        <div style={{ marginTop: "30px" }}>
            <style>{`
                .tabla-administracion tbody tr td { padding: 15px 10px !important; vertical-align: middle !important; border-bottom: 2px solid #ced4da !important; border-top: none !important; }
            `}</style>

            <h3 style={{ fontSize: "2rem", marginTop: "1.5rem", fontWeight: "bold" }}>Administrar Citas</h3>

            <div style={{ marginBottom: "25px", background: "#f8f9fa", padding: "15px", borderRadius: "8px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "15px" }}>
                <div>
                    <span style={{ marginRight: "10px", fontWeight: "500" }}>Filtrar citas por día:</span>
                    <DatePicker locale={es} selected={filtroFecha} onChange={(date) => setFiltroFecha(date)} placeholderText="Selecciona fecha" dateFormat="yyyy-MM-dd" isClearable className="form-control d-inline-block" style={{ width: "auto" }} />
                </div>
                <BotonExportarCSV filtroFecha={filtroFecha} />
            </div>

            {/* Componente 1: Clientes */}
            <TablaCitasClientes 
                citas={citasNormales}
                loading={loadingNormales}
                pagina={paginaNormales}
                totalPaginas={totalPaginasNormales}
                totalCitas={totalCitasNormales}
                setPagina={setPaginaNormales}
                onToggleConfirmada={toggleConfirmada}
                onTogglePago={togglePago}
                onEliminar={(id) => ejecutarEliminacion(id, false)}
            />

            <hr style={{ margin: "40px 0", borderTop: "2px dashed #ccc" }} />

            {/* Componente 2: Bloqueos Ficticios */}
            <TablaCitasFicticias 
                citas={citasFicticias}
                loading={loadingFicticias}
                pagina={paginaFicticias}
                totalPaginas={totalPaginasFicticias}
                totalCitas={totalCitasFicticias}
                setPagina={setPaginaFicticias}
                onDesbloquear={(id) => ejecutarEliminacion(id, true)}
            />
            <AdminEstadisticas />
        </div>
    );
};

export default AdminCitas;